// src/terms.js
const termsContent = {
    en: `
  ## 1. Data Collection and Use
  We collect and use your personal data (name, email, etc.) solely for the purpose of organizing and booking tours in Armenia. Your data will be used only to contact you, confirm bookings, and provide you with necessary information about the tours.
  
  ## 2. Use of the Website
  You agree to use the website for searching, selecting, and booking tours in accordance with the law and the rules stated in this agreement.
  
  ## 3. Processing of Personal Data
  You consent to the processing of your personal data for the purpose of organizing the tour, including sending confirmations, offers, and other important information related to your booking.
  
  ## 4. Limitation of Liability
  We are not responsible for any loss or damage arising from the use of our website or unforeseen circumstances related to the organization of tours.
  
  ## 5. Changes to the Terms
  We reserve the right to make changes to this agreement. Continuing to use the website after changes are made constitutes your acceptance of the new terms.
  
  ## 6. Contact
  If you have any questions about the terms of use or data processing, you can contact us at: parmanitour@gmail.com.
  `,
    ru: `
  ## 1. Сбор и использование данных
  Мы собираем и используем ваши персональные данные (имя, почта и т.д.) исключительно для организации и резервирования туров в Армении. Ваши данные будут использованы только для связи с вами, подтверждения бронирования и предоставления вам необходимой информации о турах.
  
  ## 2. Использование сайта
  Вы соглашаетесь использовать сайт для поиска, выбора и бронирования туров в соответствии с законом и правилами, указанными в данном соглашении.
  
  ## 3. Обработка персональных данных
  Вы даете согласие на обработку ваших персональных данных для целей организации тура, включая отправку подтверждений, предложений и другой важной информации, связанной с вашим бронированием.
  
  ## 4. Ограничение ответственности
  Мы не несем ответственности за любые убытки или ущерб, возникшие в результате использования нашего сайта или непредвиденных обстоятельств, связанных с организацией туров.
  
  ## 5. Изменение условий
  Мы оставляем за собой право вносить изменения в настоящее соглашение. Продолжение использования сайта после внесения изменений означает ваше согласие с новыми условиями.
  
  ## 6. Контакты
  Если у вас есть вопросы по поводу условий использования или обработки данных, вы можете связаться с нами по адресу электронной почты: parmanitour@gmail.com.
  `,
    hy: `
  ## 1. Տվյալների հավաքում և օգտագործում
  Մենք հավաքում և օգտագործում ենք ձեր անձնական տվյալները (անուն, էլ․ փոստ և այլն) բացառապես Հայաստանի տուրերի կազմակերպման և գրանցման նպատակով: Ձեր տվյալները կօգտագործվեն միայն ձեզ հետ կապ հաստատելու, գրանցումները հաստատելու և ձեզ անհրաժեշտ տեղեկատվություն տրամադրելու համար:
  
  ## 2. Վեբ կայքի օգտագործում
  Դուք համաձայնում եք օգտագործել կայքը տուրեր փնտրելու, ընտրելու և գրանցելու նպատակով համաձայն իրավունքի և այս համաձայնագրում նշված կանոնների:
  
  ## 3. Անձնական տվյալների մշակումը
  Դուք համաձայնում եք ձեր անձնական տվյալների մշակմանը տուրի կազմակերպման նպատակով, այդ թվում՝ հաստատումների, առաջարկների և այլ կարևոր տեղեկատվության ուղարկման համար, որը կապված է ձեր գրանցման հետ:
  
  ## 4. Պատասխանատվության սահմանափակում
  Մենք պատասխանատվություն չենք կրում մեր կայքի օգտագործման կամ տուրերի կազմակերպման հետ կապված անսպասելի հանգամանքների արդյունքում առաջացած կորուստների կամ վնասների համար:
  
  ## 5. Հաջորդականության փոփոխություն
  Մենք ourselves իրավունք ենք վերապահում փոփոխություններ կատարելու այս համաձայնագրում: Կայքի շարունակական օգտագործումը փոփոխություններից հետո նշանակում է ձեր համաձայնությունը նոր պայմանների հետ:
  
  ## 6. Կապ
  Եթե դուք ունեք որևէ հարցեր օգտագործման պայմանների կամ տվյալների մշակման մասին, կարող եք կապվել մեզ հետ էլեկտրոնային փոստի հասցեով: parmanitour@gmail.com.
  `
  };
  
  export default termsContent;
  